import { datadogRum } from "@datadog/browser-rum";

export function addError(error: unknown, context?: object | undefined) {
  datadogRum.addError(error, context);
}
